import { render, staticRenderFns } from "./FakeTabs.vue?vue&type=template&id=e1ff6d24&"
import script from "./FakeTabs.vue?vue&type=script&lang=js&"
export * from "./FakeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports